export const GAME_TITLE = 'Wordle (Сахалыы)'
export const GAME_DESC = 'Игра Wordle на якутском языке'

export const WIN_MESSAGES = ['Эҕэрдэ!', 'Сөп эппиэт', 'Сөрү сөп!']
export const GAME_COPIED_MESSAGE = 'Оонньуу копияланна'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Буукуба тиийбэт'
export const WORD_NOT_FOUND_MESSAGE = 'Тыл суох испиэһэккэ'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `Сөп эппиэт - ${solution}`
export const ENTER_TEXT = 'Киллэр'
export const STATISTICS_TITLE = 'Ахсаан'
export const GUESS_DISTRIBUTION_TEXT = 'Таайыы'
export const NEW_WORD_TEXT = 'Аныгыс тылга диэри'
export const X_TEXT = 'X.com'
export const VK_TEXT = 'ВКонтакте'
export const SHARE_TEXT = 'Кэпсээ'
export const COPY_TEXT = 'Копиялаа'
export const TOTAL_TRIES_TEXT = 'оонньуу'
export const SUCCESS_RATE_TEXT = 'кыайыы'
export const CURRENT_STREAK_TEXT = 'субуруччу'
export const BEST_STREAK_TEXT = 'рекорд'
